import { render } from "./UserUpdate.vue?vue&type=template&id=d63be17e&ts=true"
import script from "./UserUpdate.vue?vue&type=script&lang=ts"
export * from "./UserUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__